import { Action } from '@ngrx/store';


import { SingleResponseModel } from '../../../../common/models/single-response.model';
import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';

import { SummaryInvestmentAssetIntangibleModel } from '../../models/summary-investment-asset-intangible.model';


export enum InvestmentAssetIntangibleActionTypes {
  LoadInvestmentAssetIntangibles = '[InvestmentAssetIntangibles] Load InvestmentAssetIntangibles',
  LoadInvestmentAssetIntangiblesSuccess = '[InvestmentAssetIntangibles] Load InvestmentAssetIntangibles Success',
  LoadInvestmentAssetIntangiblesFailure = '[InvestmentAssetIntangibles] Load InvestmentAssetIntangibles Failure',

  LoadInvestmentAssetIntangible = '[InvestmentAssetIntangible] Load InvestmentAssetIntangible',
  LoadInvestmentAssetIntangibleSuccess = '[InvestmentAssetIntangible] Load InvestmentAssetIntangible Success',
  LoadInvestmentAssetIntangibleFailure = '[InvestmentAssetIntangible] Load InvestmentAssetIntangible Failure',

  CreateInvestmentAssetIntangible = '[InvestmentAssetIntangible] Create InvestmentAssetIntangible',
  CreateInvestmentAssetIntangibleSuccess = '[InvestmentAssetIntangible] Create InvestmentAssetIntangible Success',
  CreateInvestmentAssetIntangibleFailure = '[InvestmentAssetIntangible] Create InvestmentAssetIntangible Failure',

  UpdateInvestmentAssetIntangible = '[InvestmentAssetIntangible] Update InvestmentAssetIntangible',
  UpdateInvestmentAssetIntangibleSuccess = '[InvestmentAssetIntangible] Update InvestmentAssetIntangible Success',
  UpdateInvestmentAssetIntangibleFailure = '[InvestmentAssetIntangible] Update InvestmentAssetIntangible Failure',

  DeleteInvestmentAssetIntangible = '[InvestmentAssetIntangible] Delete InvestmentAssetIntangible',
  DeleteInvestmentAssetIntangibleSuccess = '[InvestmentAssetIntangible] Delete InvestmentAssetIntangible Success',
  DeleteInvestmentAssetIntangibleFailure = '[InvestmentAssetIntangible] Delete InvestmentAssetIntangible Failure',
}

/** Load all */

export class LoadInvestmentAssetIntangibles implements Action {
  readonly type = InvestmentAssetIntangibleActionTypes.LoadInvestmentAssetIntangibles;
  constructor(public payload: {filter: any}) {}
}

export class LoadInvestmentAssetIntangiblesSuccess implements Action {
  readonly type = InvestmentAssetIntangibleActionTypes.LoadInvestmentAssetIntangiblesSuccess;
  constructor(public payload: { items: SummaryInvestmentAssetIntangibleModel[]; total: number }) {}
}

export class LoadInvestmentAssetIntangiblesFailure implements Action {
  readonly type = InvestmentAssetIntangibleActionTypes.LoadInvestmentAssetIntangiblesFailure;
  constructor(public payload: { error: any }) {}
}

/** Load by id */

export class LoadInvestmentAssetIntangible implements Action {
  readonly type = InvestmentAssetIntangibleActionTypes.LoadInvestmentAssetIntangible;
  constructor(public payload: { uid: string }) {}
}

export class LoadInvestmentAssetIntangibleSuccess implements Action {
  readonly type = InvestmentAssetIntangibleActionTypes.LoadInvestmentAssetIntangibleSuccess;
  constructor(public payload: SingleResponseModel<SummaryInvestmentAssetIntangibleModel>) {}
}

export class LoadInvestmentAssetIntangibleFailure implements Action {
  readonly type = InvestmentAssetIntangibleActionTypes.LoadInvestmentAssetIntangibleFailure;
  constructor(public payload: { error: any }) {}
}

/** Create */

export class CreateInvestmentAssetIntangible implements Action {
  readonly type = InvestmentAssetIntangibleActionTypes.CreateInvestmentAssetIntangible;
  constructor(public payload: { investmentAsset: SummaryInvestmentAssetIntangibleModel }) {}
}


export class CreateInvestmentAssetIntangibleSuccess implements Action {
  readonly type = InvestmentAssetIntangibleActionTypes.CreateInvestmentAssetIntangibleSuccess;
  constructor(public payload: { investmentAsset: SummaryInvestmentAssetIntangibleModel }) {}
}

export class CreateInvestmentAssetIntangibleFailure implements Action {
  readonly type = InvestmentAssetIntangibleActionTypes.CreateInvestmentAssetIntangibleFailure;
  constructor(public payload: { error: any }) {}
}


/** Update */

export class UpdateInvestmentAssetIntangible implements Action {
  readonly type = InvestmentAssetIntangibleActionTypes.UpdateInvestmentAssetIntangible;
  constructor(public payload: { investmentAsset: SummaryInvestmentAssetIntangibleModel }) {}
}

export class UpdateInvestmentAssetIntangibleSuccess implements Action {
  readonly type = InvestmentAssetIntangibleActionTypes.UpdateInvestmentAssetIntangibleSuccess;
  constructor(public payload: { investmentAsset: SummaryInvestmentAssetIntangibleModel }) {}
}

export class UpdateInvestmentAssetIntangibleFailure implements Action {
  readonly type = InvestmentAssetIntangibleActionTypes.UpdateInvestmentAssetIntangibleFailure;
  constructor(public payload: { error: any }) {}
}


/** Delete */

export class DeleteInvestmentAssetIntangible implements Action {
  readonly type = InvestmentAssetIntangibleActionTypes.DeleteInvestmentAssetIntangible;
  constructor(public payload: { uid: string }) {}
}

export class DeleteInvestmentAssetIntangibleSuccess implements Action {
  readonly type = InvestmentAssetIntangibleActionTypes.DeleteInvestmentAssetIntangibleSuccess;
  constructor(public payload: { uid: string }) {}
}

export class DeleteInvestmentAssetIntangibleFailure implements Action {
  readonly type = InvestmentAssetIntangibleActionTypes.DeleteInvestmentAssetIntangibleFailure;
  constructor(public payload: { error: any }) {}
}

export type InvestmentAssetIntangibleActions =
  | LoadInvestmentAssetIntangibles
  | LoadInvestmentAssetIntangiblesSuccess
  | LoadInvestmentAssetIntangiblesFailure
  | LoadInvestmentAssetIntangible
  | LoadInvestmentAssetIntangibleSuccess
  | LoadInvestmentAssetIntangibleFailure
  | CreateInvestmentAssetIntangible
  | CreateInvestmentAssetIntangibleSuccess
  | CreateInvestmentAssetIntangibleFailure
  | UpdateInvestmentAssetIntangible
  | UpdateInvestmentAssetIntangibleSuccess
  | UpdateInvestmentAssetIntangibleFailure
  | DeleteInvestmentAssetIntangible
  | DeleteInvestmentAssetIntangibleSuccess
  | DeleteInvestmentAssetIntangibleFailure
